export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_NOT_LOGIN_ACCOUNT = 'SET_NOT_LOGIN_ACCOUNT'

export default {
  SET_ACCOUNT,
  SET_NOT_LOGIN_ACCOUNT
}
